<template>
    <div class="plans-carousel-wrapper">
        <div class="carousel-nav-container">
            <button v-if="filteredPlans.length > 4 && !scrollAtStart" type="button" class="carousel-arrow left"
                @click="scrollCarousel('left')">
                <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                    <path
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                </svg>
            </button>

            <div class="plans-carousel-container" ref="plansCarousel">
                <div class="plans-row" :class="'plans-count-' + filteredPlans.length">
                    <div v-for="(plan, index) in filteredPlans" :key="plan.id" class="plan-card-item"
                        :class="{ 'plan-selected': selectedPlanId == plan.id }" @click="handlePlanSelection(plan.id)">
                        <div class="plan-card-header">
                            <h3 class="plan-name">{{ plan.name }}</h3>
                            <div class="plan-price-large">
                                {{ calculatePlanPrice(plan) }} <span class="currency">€ <small
                                        class="fs-05 text-muted">TTC</small></span>
                            </div>
                        </div>

                        <!-- NEW: Plan Stats Grid -->
                        <div class="plan-stats-container">
                            <div class="plan-stats-grid" :class="'cols-' + getPlanStatsCols(plan.name)">
                                <div class="stat-item" v-if="getPlanStats(plan.name).vetuste !== undefined">
                                    <div class="stat-icon-wrapper">
                                        <img src="../../../assets/clock-twise.svg" class="stat-icon" />
                                    </div>
                                    <div class="stat-content">
                                        <span class="stat-label">VETUSTE</span>
                                        <span class="stat-value">{{ getPlanStats(plan.name).vetuste }}</span>
                                    </div>
                                </div>
                                <div class="stat-item" v-if="getPlanStats(plan.name).franchise !== undefined">
                                    <div class="stat-icon-wrapper">
                                        <img src="../../../assets/clock-twise.svg" class="stat-icon" />
                                    </div>
                                    <div class="stat-content">
                                        <span class="stat-label">FRANCHISE</span>
                                        <span class="stat-value">{{ getPlanStats(plan.name).franchise }}</span>
                                    </div>
                                </div>
                                <div class="stat-item full-width" v-if="getPlanStats(plan.name).plafond !== undefined">
                                    <div class="stat-icon-wrapper">
                                        <font-awesome-icon icon="shield-alt" class="stat-icon" />
                                    </div>
                                    <div class="stat-content">
                                        <span class="stat-label">PLAFOND</span>
                                        <span class="stat-value">{{ getPlanStats(plan.name).plafond }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="refund-table-btn" v-if="![1, 2, 3].includes(plan.id)">
                                TABLEAU DE REMBOURSEMENT PIECES ET MAIN D'OEUVRE
                            </div>

                            <div v-if="getPlanStats(plan.name).vetusteNotice" class="vetuste-notice">
                                <font-awesome-icon icon="info-circle" />
                                <span>{{ getPlanStats(plan.name).vetusteNotice }}</span>
                            </div>
                        </div>

                        <!-- Features List -->
                        <div class="plan-features-new">
                            <div v-if="getPreviousPlanName(index)" class="cumulative-plan-card">
                                <span class="cumulative-text">Pièces de la garantie {{
                                    getPreviousPlanName(index) }}</span>
                            </div>
                            <div v-else class="cumulative-plan-card placeholder-card"
                                style="visibility: hidden; border: none; margin-bottom: 10px; padding: 10px;">
                                <span class="cumulative-text">&nbsp;</span>
                            </div>
                            <div v-if="getPreviousPlanName(index)" class="plus-icon-divider">
                                <font-awesome-icon icon="plus-circle" />
                            </div>
                            <div v-else class="plus-icon-divider placeholder-divider"
                                style="visibility: hidden; margin-bottom: 10px; line-height: 1;">
                                <font-awesome-icon icon="plus-circle" />
                            </div>
                            <ul class="features-list">
                                <li v-for="(feature, fIndex) in getNewFeatures(plan.id, index)" :key="fIndex"
                                    class="feature-item">
                                    <font-awesome-icon icon="check-circle" class="check-icon" />
                                    <span class="feature-title">
                                        {{ feature.title }}
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <div class="plan-footer-links">
                            <!-- <a v-if="isNoticeAvailable" :href="getUrl(plan)" target="_blank" class="footer-link">
                                <font-awesome-icon icon="file-alt" /> Notice d'assurance
                            </a> -->
                            <a href="#" class="footer-link" @click.prevent="openIPID(plan)">
                                <font-awesome-icon icon="file-pdf" /> Plaquette d’informations
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <button v-if="filteredPlans.length > 4 && !scrollAtEnd" type="button" class="carousel-arrow right"
                @click="scrollCarousel('right')">
                <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                    <path
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                </svg>
            </button>
        </div>

        <!-- No Plans Available Message -->
        <transition name="fade">
            <div v-if="!isBusy && apiCalled && filteredPlans.length === 0" class="no-plans-overlay">
                <div class="no-plans-content">
                    <div class="error-icon-wrapper">
                        <font-awesome-icon prefix="fas" icon="exclamation-circle" />
                    </div>
                    <h2>Aucun plan disponible</h2>
                    <p>Désolé, mais aucune garantie ne correspond aux critères de votre véhicule.</p>
                    <button class="btn btn-primary mt-4" @click="goBackToStep1">
                        Modifier les informations du véhicule
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "InsurancePlansCarousel",
    props: {
        plans: {
            type: Array,
            required: true
        },
        selectedPlanId: {
            type: [Number, String],
            default: null
        },
        duration: {
            type: [Number, String],
            default: 0
        },
        vehicle: {
            type: Object,
            default: () => ({})
        },
        apiUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isBusy: false,
            apiCalled: false,
            apiPrices: {},
            validPlanIds: [],
            scrollProgress: 0,
            scrollAtStart: true,
            scrollAtEnd: false,
        };
    },
    watch: {
        duration: {
            handler(newVal) {
                if (newVal) {
                    this.getPlans();
                }
            }
        },
        selectedPlanId: {
            handler(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        this.scrollToSelectedPlan(newVal);
                    });
                }
            },
            immediate: true
        }
    },
    computed: {
        filteredPlans() {
            // If API hasn't been called yet, show all prop plans as fallback
            if (!this.apiCalled) return this.plans;
            // Filter plans based on valid IDs returned from API
            return this.plans.filter(p => this.validPlanIds.some(vId => vId == p.id));
        },
        engine() {
            return this.vehicle ? +this.vehicle.carburant : null;
        },
        indicatorStyle() {
            return {
                left: `${this.scrollProgress}%`,
                width: '40%'
            };
        },
        isNoticeAvailable() {
            // Notice d'assurance is currently only confirmed for Auto plans
            return this.apiUrl && (this.apiUrl.includes('auto') || this.apiUrl.includes('auto-electrique'));
        }
    },
    methods: {
        getUrl(plan) {
            let type = 'auto';
            if (this.apiUrl.includes('moto')) {
                type = 'moto';
            } else if (this.apiUrl.includes('camping-car')) {
                type = 'camping-car';
            }

            // Notice is currently available only for Auto
            if (type !== 'auto') return '#';

            // Handle electric auto if necessary
            if (type === 'auto' && this.vehicle && +this.vehicle.carburant === 4) {
                type = 'auto-electrique';
            }

            // Construct authenticated URL for Notice d'assurance
            return this.getRawApiUrl('api/ipid') + `&doc_type=notice&plan=${encodeURIComponent(plan.name)}&type=${type}`;
        },
        getPlans() {

            this.isBusy = true; // start loader

            let url = "plans" + this.apiUrl;

            // get data from form / quote
            let data = this.vehicle;

            // prepare payload for backend
            let payload = {
                // fuel type
                car_fuel: data.carburant || 0,

                // convert effective date to YYYY-MM-DD
                effective_date: (data.annee_prise_effet && data.mois_prise_effet && data.jour_prise_effet)
                    ? `${data.annee_prise_effet}-${String(data.mois_prise_effet).padStart(2, '0')}-${String(data.jour_prise_effet).padStart(2, '0')}`
                    : null,

                // convert circulation date to YYYY-MM-DD
                date_circulation: (data.annee_mise_en_circulation && data.mois_mise_en_circulation && data.jour_mise_en_circulation)
                    ? `${data.annee_mise_en_circulation}-${String(data.mois_mise_en_circulation).padStart(2, '0')}-${String(data.jour_mise_en_circulation).padStart(2, '0')}`
                    : null,

                // vehicle details
                km_real: parseInt(data.km_reel || 0),
                km_sale_day: parseInt(data.km_jour_vente || 0),

                type_vehicle: data.type_vehicule || 0,
                garantie: this.plans.map((plan) => plan.id),
                duration: data.duree,
                cylinder: parseInt(data.cylindree || 0),
                power_kw: data.power_kw || 0,

                // extra fields
                is_new: data.is_new || 'Non',
                mechanic_id: this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : null,
                quote_id: this.$route.params.id || null,

                priceSide: "grossiste-particuliers"
            };


            // call API with payload
            this.apiPost(url, payload)
                .then(response => {
                    this.apiCalled = true;
                    const data = response.data;
                    const newPrices = {};

                    if (Array.isArray(data)) {
                        data.forEach(item => {
                            const planId = Number(item.garantie);
                            if (item.price) {
                                newPrices[planId] = parseFloat(item.price);
                            }
                        });
                    } else if (data && typeof data === 'object') {
                        // Support for previous nested object format if needed
                        Object.keys(data).forEach(key => {
                            const planId = Number(key);
                            const options = data[key];

                            if (Array.isArray(options) && options.length > 0) {
                                const firstOption = options[0];
                                if (firstOption && firstOption.price) {
                                    newPrices[planId] = parseFloat(firstOption.price);
                                }
                            } else if (typeof options === 'number' || typeof options === 'string') {
                                newPrices[planId] = parseFloat(options);
                            }
                        });
                    }

                    this.apiPrices = newPrices;
                    this.validPlanIds = Object.keys(newPrices).map(Number);

                    this.isBusy = false;

                    // Automatically select default guarantee
                    if (this.filteredPlans.length > 0 && (this.selectedPlanId == 0 || !this.selectedPlanId)) {
                        let defaultId;
                        if (this.filteredPlans.length === 2) {
                            // If exactly 2 items, select the last item
                            defaultId = this.filteredPlans[1].id;
                        } else if (this.filteredPlans.length > 2) {
                            // If more than 2 items, select the second-to-last item
                            defaultId = this.filteredPlans[this.filteredPlans.length - 2].id;
                        } else {
                            // If only 1 item, select that one
                            defaultId = this.filteredPlans[0].id;
                        }
                        this.handlePlanSelection(defaultId);
                    } else if (this.selectedPlanId) {
                        // Auto-scroll to selected plan
                        this.handlePlanSelection(this.selectedPlanId);
                    }
                    this.$nextTick(() => {
                        setTimeout(() => {
                            if (this.selectedPlanId) {
                                this.scrollToSelectedPlan(this.selectedPlanId);
                            } else if (this.filteredPlans.length > 4) {
                                // Fallback: Scroll to end to show premium plans
                                this.scrollToSelectedPlan(this.filteredPlans[this.filteredPlans.length - 1].id);
                            }
                        }, 500);
                    });
                })
                .catch(error => {
                    this.isBusy = false;
                    this.apiCalled = true;
                    this.showErrorNotification(error);
                });
        },
        goBackToStep1() {
            this.$emit('go-to-step', 1);
        },
        calculatePlanPrice(plan) {
            // Strictly use API price
            const price = this.apiPrices[plan.id];
            return price !== undefined ? price : '0.00';
        },

        getDetailedFeatures(planId) {
            const plan = this.plans.find(p => p.id === planId);
            const features = (plan && plan.detailedFeatures) ? plan.detailedFeatures : [];
            return features.filter(f => f.title.toLowerCase() !== 'important' && f.title.toLowerCase() !== 'Important' && f.title.toLowerCase() !== 'import');
        },
        getPlanStatsCols(planName) {
            const stats = this.getPlanStats(planName);
            let count = 0;
            if (stats.vetuste !== undefined) count++;
            if (stats.franchise !== undefined) count++;
            // if (stats.plafond !== undefined) count++;
            return count;
        },
        getPlanStats(pname) {

            const name = pname.toUpperCase();

            switch (name) {
                case 'RÉSEAU':
                    return { vetuste: "0€", franchise: "0€" };

                case 'MAXI RÉSEAU':
                    return { vetuste: "0€", franchise: "0€" };

                case 'MAXI PLUS':
                    return { franchise: "10% minimum 76 €", vetusteNotice: "Vétusté applicable sur les pièces" };

                case 'PRESTIGE':
                    return { vetuste: "0€", franchise: "0€", plafond: "Sans" };

                case 'STANDARD':
                    return { vetuste: "0€", franchise: "0€", plafond: "Jusqu'à 1 200 €" };

                default:
                    return {};
            }
        }
        ,
        getPreviousPlanName(index) {
            if (index === 0) return null;

            const previousPlan = this.filteredPlans[index - 1];
            if (!previousPlan) return null;

            return previousPlan.name.toUpperCase();
        }
        ,

        getNewFeatures(planId, index) {
            const currentFeatures = this.getDetailedFeatures(planId);

            // First plan => show all
            if (planId === 3) {
                return [
                    { title: "Moteur (pièces internes)" },
                    { title: "Boîte de vitesses" },
                    { title: "Dispositif de transmission" }
                ];
            }

            // RÉSEAU (ID 4)
            if (planId == 4) {
                return [
                    { title: "Refroidissement" },
                    { title: "Système de freinage (base)" },
                    { title: "Système d’alimentation" },
                    { title: "Dispositif d’embrayage" },
                    { title: "Composants pour vh hybrides" },
                ];
            }

            // MAXI RÉSEAU (ID 5)
            if (planId == 5) {
                return [
                    { title: "Système électrique" },
                    { title: "Système de direction" },
                    { title: "Système de freinage étendu" },
                    { title: "Système d’alimentation étendu" },
                    { title: "Dispositif d’embrayage étendu" },
                ];
            }

            // MAXI PLUS (ID 1)
            if (planId == 1) {
                return [
                    { title: "Système de suspension" },
                    { title: "Refroidissement étendu" },
                    { title: "Système de direction étendu" },
                    { title: "Système de freinage étendu" },
                    { title: "Système d’alimentation étendu" },
                    { title: "Dispositif d’embrayage étendu" },
                ];
            }

            // PRESTIGE (ID 2)
            if (planId == 2) {
                return [
                    { title: "Calculateur de BVA" },
                ];
            }



            return currentFeatures;
        },
        scrollCarousel(direction) {
            const container = this.$refs.plansCarousel;
            if (!container) return;

            // Get actual card width dynamically
            const card = container.querySelector('.plan-card-item');
            if (!card) return;

            const cardWidth = card.offsetWidth;
            const gap = 20; // gap from styleV2.scss
            const scrollAmount = direction === 'left' ? -(cardWidth + gap) : (cardWidth + gap);

            container.scrollBy({ left: scrollAmount, behavior: 'smooth' });

            // Update indicator (simplified)
            setTimeout(() => {
                const maxScroll = container.scrollWidth - container.clientWidth;
                if (maxScroll > 0) {
                    this.scrollProgress = (container.scrollLeft / maxScroll) * 60; // 60 to keep it within bar
                }
            }, 300);
        },
        scrollToSelectedPlan(planId) {
            const container = this.$refs.plansCarousel;
            if (!container) return;

            // Find index
            const index = this.filteredPlans.findIndex(p => p.id == planId);
            if (index === -1) return;

            // Get actual card width dynamically
            const card = container.querySelector('.plan-card-item');
            if (!card) return;

            const cardWidth = card.offsetWidth;
            const gap = 15; // gap set in styleV2.scss
            const scrollPosition = index * (cardWidth + gap);

            container.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
            });

            // Update indicator
            const maxScroll = container.scrollWidth - container.clientWidth;
            if (maxScroll > 0) {
                this.scrollProgress = (scrollPosition / maxScroll) * 100;
            }
        },
        handlePlanSelection(planId) {
            const price = this.calculatePlanPrice({ id: planId });
            this.$emit('select-plan', planId, price);
            this.scrollToSelectedPlan(planId);
        },
        openIPID(plan) {
            let type = 'auto'; // Default vehicle type

            // Determine vehicle type from apiUrl prop
            if (this.apiUrl.includes('moto')) {
                type = 'moto';
            } else if (this.apiUrl.includes('camping-car')) {
                type = 'camping-car';
            } else if (this.apiUrl.includes('auto')) {
                type = 'auto';
            }

            // Handle electric auto
            // 4 is the ID for ELECTRIC in AUTO_ENGINE constants
            if (type === 'auto' && this.vehicle && +this.vehicle.carburant === 4) {
                type = 'auto-electrique';
            }

            // Construct the URL for the IPID dynamic server
            // Use getRawApiUrl to include authentication token
            const url = this.getRawApiUrl('api/ipid') + `&plan=${encodeURIComponent(plan.name)}&type=${type}`;

            // Open in new tab
            window.open(url, '_blank');
        },
        handleScroll() {
            const container = this.$refs.plansCarousel;
            if (!container) return;

            const { scrollLeft, scrollWidth, clientWidth } = container;
            this.scrollAtStart = scrollLeft <= 10;
            this.scrollAtEnd = scrollLeft + clientWidth >= scrollWidth - 10;

            // Update indicator (simplified)
            const maxScroll = scrollWidth - clientWidth;
            if (maxScroll > 0) {
                this.scrollProgress = (scrollLeft / maxScroll) * 60; // 60 to keep it within bar
            }
        }

    },
    mounted() {
        this.getPlans();
        this.$nextTick(() => {
            const container = this.$refs.plansCarousel;
            if (container) {
                container.addEventListener('scroll', this.handleScroll);
                // Initial check
                setTimeout(this.handleScroll, 1000);
            }
        });
    },
    beforeDestroy() {
        const container = this.$refs.plansCarousel;
        if (container) {
            container.removeEventListener('scroll', this.handleScroll);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/shared/InsurancePlansCarousel.vue